export enum NewbornPostpartumEncounterQuestionnaireURLs {
  Size = "http://quiltedhealth.com/q/newborn-postpartum-size",
  VitalsSign = "http://quiltedhealth.com/q/newborn-postpartum-vitals-sign",
  MedicationsTherapies = "http://quiltedhealth.com/q/newborn-postpartum-medication-and-therapies",
  InputsOutputs = "http://quiltedhealth.com/q/newborn-postpartum-input-output",
  Encounter = "http://quiltedhealth.com/q/newborn-postpartum-encounter",
  StateOfNewborn = "http://quiltedhealth.com/q/newborn-postpartum-state-of-newborn",
}

export enum NewbornPostpartumVitalsSignQuestionsLinkIds {
  Date = "vitalsSignDate",
  Time = "vitalsSignTime",
  HeartRate = "vitalsSignHeartRate",
  RespiratoryRate = "vitalsSignRespiratoryRate",
  Temperature = "vitalsSignTemperature",
  TemperatureUnit = "vitalsSignTemperatureUnit",
  TemperatureMethod = "vitalsSignTemperatureMethod",
  Color = "vitalsSignColor",
  Jaundice = "vitalsSignJaundice",
  Void = "vitalsSignVoid",
  Stool = "vitalsSignStool",
  Notes = "vitalsSignNotes",
}

export enum NewbornPostpartumSizeQuestionsLinkIds {
  Scale = "sizeScale",
  Weight = "sizeWeight",
  WeightOunces = "sizeWeightOunces",
  Length = "sizeLength",
  HeadCircumference = "sizeHeadCircumference",
  ChestCircumference = "sizeChestCircumference",
  Notes = "sizeNotes",
}

export enum NewbornPostpartumMedicationsTherapiesQuestionsLinkIds {
  GeneralNotes = "newbornPostpartumMedsAndTherapiesGeneralNotes",
  MedicationFormset = "newbornPostpartumMedicationFormset",
  MedicationFormsetCode = "newbornPostpartumMedicationFormsetCode",
  TherapiesFormset = "newbornPostpartumTherapiesFormset",
  TherapiesFormsetCode = "newbornPostpartumTherapiesFormsetCode",
}

export enum NewbornPostpartumEncounterDrawerActions {
  Save = "save",
  SignAndLock = "signAndLock",
}

export enum NewbornPostpartumEncounterQuestionsLinkIds {
  EncounterNote = "notes",
  EncounterTemplate = "encounterTemplate",
  EncounterType = "encounterType",
  EncounterLocation = "encounterLocation",
  EncounterAmendmentInfoReason = "encounterAmendmentInfoReason",
  EncounterAmendmentInfoSpecify = "encounterAmendmentInfoSpecify",
  EncounterAmendmentInfoNotes = "encounterAmendmentInfoNotes",
  EncounterAmendmentInfoNotifyClient = "encounterAmendmentInfoNotifyClient",
  EncounterDiagnosisCode = "encounterClientDiagnosisCode",
  EncounterDiagnosisAddToProblemList = "encounterClientDiagnosisAddToProblemList",
  EncounterDiagnosisNotes = "encounterClientDiagnosisNotes",
}

export enum NewbornPostpartumStateOfNewbornQuestionsLinkIds {
  Sex = "stateOfNewbornSex",
  SexSpecify = "stateOfNewbornSexSpecify",
  NewbornName = "newbornName",
  NewbornState = "stateOfNewborn",
}

export enum NewbornPostpartumInputsOutputsQuestionsLinkIds {
  FeedingType = "inputOutputFeedingType",
  FeedingSupplementAmount = "inputOutputFeedingSupplementAmount",
  FeedingLength = "inputOutputFeedingLength",
  FeedingBehavior = "inputOutputFeedingBehavior",
  FeedingSupplement = "inputOutputFeedingSupplement",
  FeedingSupplementAmountPumpedMilk = "inputOutputFeedingSupplementAmountPumpedMilk",
  FeedingSupplementAmountUnitPumpedMilk = "inputOutputFeedingSupplementAmountUnitPumpedMilk",
  FeedingSupplementAverageAmountPumpedMilk = "inputOutputFeedingSupplementAverageAmountPumpedMilk",
  FeedingSupplementAmountDonorMilk = "inputOutputFeedingSupplementAmountDonorMilk",
  FeedingSupplementAmountUnitDonorMilk = "inputOutputFeedingSupplementAmountUnitDonorMilk",
  FeedingSupplementAverageAmountDonorMilk = "inputOutputFeedingSupplementAverageAmountDonorMilk",
  FeedingSupplementAmountFormula = "inputOutputFeedingSupplementAmountFormula",
  FeedingSupplementAmountUnitFormula = "inputOutputFeedingSupplementAmountUnitFormula",
  FeedingSupplementAverageAmountFormula = "inputOutputFeedingSupplementAverageAmountFormula",
  FeedingSupplementFormset = "inputOutputFeedingSupplementFormset",
  FeedingSupplementFormsetCode = "inputOutputFeedingSupplementFormsetCode",
  FeedingSupplementFormsetType = "inputOutputFeedingSupplementFormsetType",
  FormsetTypeFeedingSupplementAmountPumpedMilk = "inputOutputFormsetTypeFeedingSupplementAmountPumpedMilk",
  FormsetTypeFeedingAmountUnitPumpedMilk = "inputOutputFormsetTypeFeedingAmountUnitPumpedMilk",
  FormsetTypeFeedingAverageAmountPumpedMilk = "inputOutputFormsetTypeFeedingAverageAmountPumpedMilk",
  FormsetTypeFeedingSupplementAmountDonorMilk = "inputOutputFormsetTypeFeedingSupplementAmountDonorMilk",
  FormsetTypeFeedingAmountUnitDonorMilk = "inputOutputFormsetTypeFeedingAmountUnitDonorMilk",
  FormsetTypeFeedingAverageAmountDonorMilk = "inputOutputFormsetTypeFeedingAverageAmountDonorMilk",
  FormsetTypeFeedingSupplementAmountFormula = "inputOutputFormsetTypeFeedingSupplementAmountFormula",
  FormsetTypeFeedingAmountUnitFormula = "inputOutputFormsetTypeFeedingAmountUnitFormula",
  FormsetTypeFeedingAverageAmountFormula = "inputOutputFormsetTypeFeedingAverageAmountFormula",
  Voiding = "inputOutputVoiding",
  VoidingNormal = "inputOutputVoidingNormal",
  VoidingNotNormal = "inputOutputVoidingNotNormal",
  Bowel = "inputOutputBowel",
  BowelNormal = "inputOutputBowelNormal",
  BowelNotNormal = "inputOutputBowelNotNormal",
  Notes = "inputOutputNotes",
}

export enum NewbornPostpartumInputsOutputsQuestionsDisplayNames {
  FeedingType = "Breast/Chest Feeding",
  BreastChestFeedingsAmount = "Number of breast/chest feedings in the last 24 hours",
  SupplementAmount = "Number of supplement feedings in the last 24 hours",
  FeedingLength = "Average length of feedings",
  FeedingBehavior = "Baby's behavior during and after breast/chest feeding",
  SupplementType = "Supplement Type",
  SupplementAverageAmount = "Average amount of supplemental feeding",
  SupplementFormset = "Additional Supplements",
  SupplementFormsetCode = "Supplement Code",
  Voiding = "Voiding",
  Normal = "Normal Notes",
  NotNormal = "Not Normal Notes",
  Bowel = "Bowel/Stool Movements",
  Notes = "Input & Output Notes",
}

export enum NewbornPostpartumInputsOutputLabels {
  FeedingType = "Feeding Type",
  FeedingLength = "Feeding Length",
  FeedingBehavior = "Feeding Behavior",
  BreastChestFeedingsAmount = "Number of breast/chest feedings in the last 24 hours",
  SupplementType = "Supplement Type",
  SupplementAverageAmount = "Average amount of supplemental feeding",
  SupplementFormset = "Additional Supplements",
  SupplementFormsetCode = "Supplement Code",
  PumpedMilkNumberFeedings = "Pumped Milk - Number of feedings",
  PumpedMilkAmountUnit = "Pumped Milk - Amount (unit)",
  PumpedMilkAverageAmount = "Pumped Milk - Average amount",
  DonorMilkNumberFeedings = "Donor Milk - Number of feedings",
  DonorMilkAmountUnit = "Donor Milk - Amount (unit)",
  DonorMilkAverageAmount = "Donor Milk - Average amount",
  FormulaNumberFeedings = "Formula - Number of feedings",
  FormulaAmountUnit = "Formula - Amount (unit)",
  FormulaAverageAmount = "Formula - Average amount",
  Voiding = "Voiding",
  VoidingNormalNotes = "Voiding Normal Notes",
  VoidingNotNormalNotes = "Voiding Not Normal Notes",
  Bowel = "Bowel",
  BowelNormalNotes = "Bowel Normal Notes",
  BowelNotNormalNotes = "Bowel Not Normal Notes",
  InputsOutputsNotes = "Inputs & Outputs Notes",
}

export enum NewbornPostpartumInputsOutputAdditional {
  InputOutput = "inputOutput",
  NewbornInputOutput = "newbornPostpartumInputOutput",
}

export enum NewbornPostpartumEncounterBotNames {
  Encounter = "Newborn Postpartum - Encounter",
}

export const NEWBORN_POSTPARTUM_PROCEDURES = [
  "HearingScreeningTest",
  "MetabolicScreen",
  "PulseOximetry",
  "UmbilicalCauterization",
  "Frenulectomy",
  "TranscutaneousBilirubinTesting",
  "TotalSerumBilirubinTesting",
] as const;

export const NEWBORN_POSTPARTUM_PHYSICAL_EXAMS = [
  "Head",
  "Eyes",
  "Ears",
  "NoseAndMouth",
  "Neck",
  "ChestAndAbdomen",
  "HipsAndExtremities",
  "BackAndSpine",
] as const;

export enum NewbornPostpartumHeartRateCodes {
  AbsentCode = "forms/newbornPostpartumFlowSheet/newborn_heart_rate/absent",
  Under100Code = "forms/newbornPostpartumFlowSheet/newborn_heart_rate/under_100",
  Over100Code = "forms/newbornPostpartumFlowSheet/newborn_heart_rate/over_100",
}

export enum NewbornPostpartumColorCodes {
  OtherCode = "forms/newborn-ipp-vitals-sign/color/other",
  PaleOrBlueCode = "forms/newborn-ipp-vitals-sign/color/pale-or-blue",
  PinkBodyWithBlueExtremitiesCode = "forms/newborn-ipp-vitals-sign/color/pink-body-with-blue-extremities",
  PinkCode = "forms/newborn-ipp-vitals-sign/color/pink",
}
